import { Injectable } from '@angular/core';

// workaround for https://bugs.webkit.org/show_bug.cgi?id=174667
@Injectable({ providedIn: 'root' })
export class ModalAriaService {

  init() {
    document.addEventListener('ionModalWillPresent', this.stripAriaModal);
    document.addEventListener('ionModalDidPresent', this.stripAriaModal);
  }

  private stripAriaModal = (event: Event) => {
    const modal = event.target as HTMLElement;
    modal.shadowRoot?.querySelector('.modal-wrapper')?.removeAttribute('aria-modal');
  };
}
